import { createContext, useContext } from 'react';
import type { EducationCartContextValue } from './education-cart.type';

/**
 * Provider 와 파일을 나눈다 — 컴포넌트 파일이 값·훅을 함께 export 하면
 * Fast Refresh 가 그 모듈 전체를 재평가해 편집 때마다 장바구니가 초기화된다.
 */
export const EducationCartContext =
  createContext<EducationCartContextValue | null>(null);

export function useEducationCart(): EducationCartContextValue {
  const ctx = useContext(EducationCartContext);
  if (!ctx)
    throw new Error(
      'useEducationCart 는 EducationCartProvider 안에서만 쓸 수 있습니다.',
    );
  return ctx;
}
